import { ReactComponent as LoadingIcon } from "../../assets/icons/generals/double-loading.svg"


const Loading = () => {
    return (
        <div className="flex w-full">
            <LoadingIcon className="w-[75px]" />
        </div>
    )
}

export default Loading